export const AD_LOADED = 'AD_LOADED';
export const FIRST_AD_LOADED = 'FIRST_AD_LOADED';
export const AD_ERROR = 'AD_ERROR';
export const BLOCK_COMPLETED = 'BLOCK_COMPLETED';
export const AD_CHANGED = 'AD_CHANGED';
export const AD_PLAY_STARTED = 'AD_PLAY_STARTED';
export const AD_PLAY_COMPLETED = 'AD_PLAY_COMPLETED';
export const AD_SHOW_SKIP = 'AD_SHOW_SKIP';
export const AD_PAUSED = 'AD_PAUSED';
export const AD_RESUME = 'AD_RESUME';
export const SEARCH_AD = 'SEARCH_AD';
